import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["textTools", "photoTools"]

    connect() {
        this._onInspect = (e) => {
            const kind = e.detail?.kind || "Text"
            if (kind === "Photo") this.showPhoto()
            else this.showText()
        }
        document.addEventListener("ie:inspect", this._onInspect)
    }
    disconnect() {
        document.removeEventListener("ie:inspect", this._onInspect)
    }
    showPhoto() {
        this.textToolsTarget.classList.add("d-none")
        this.photoToolsTarget.classList.remove("d-none")
    }
    showText() {
        this.photoToolsTarget.classList.add("d-none")
        this.textToolsTarget.classList.remove("d-none")
    }
}